<app-menu currentMenu="main"></app-menu>
<div class="page-index" *ngIf="data">
  <app-main-header [data]="data.header"></app-main-header>
  <app-main-about [data]="data.about"></app-main-about>
  <app-main-calculator [data]="data.calculator"></app-main-calculator>
  <app-main-plans></app-main-plans>
  <app-main-article></app-main-article>
</div>
<app-footer></app-footer>
